module.exports = __webpack_public_path__ + "media/images/badge-budget-8eacc52ba6b21810c6fa7b8edc370a2f.svg";